export const APP_MUTATION_SCOPE = { id: "app-mutation-queue" } as const;
